import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const DebugAttributeContext = createContext(dropDebugAttributes);
/**
 * Hook to add debug attributes to a component.
 *
 * @param attributes - The debug attributes to add.
 * @returns The debug attributes.
 */
function useDebugAttributes(attributes) {
    const transform = useContext(DebugAttributeContext);
    return transform(attributes);
}
/**
 * Provider to enable debug attributes in the scope of this provider.
 */
function FplDebugProvider({ children, debug }) {
    const value = debug ? prefixDebugAttributes : dropDebugAttributes;
    return jsx(DebugAttributeContext.Provider, { value: value, children: children });
}
FplDebugProvider.displayName = 'FplDebugProvider';
function dropDebugAttributes(_) {
    return {};
}
function prefixDebugAttributes(attributes) {
    if (attributes && Object.keys(attributes).length > 0) {
        return Object.fromEntries(Object.entries(attributes).map(([key, value]) => [`data-fpl-${key}`, value]));
    }
    return {};
}

export { FplDebugProvider, useDebugAttributes };
//# sourceMappingURL=use-debug-attributes.js.map
